var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SectionOuter, SectionHeading, LinkCardContentHeading, LinkCardContent, LinkCardIconAdd, LinkCardIconLearn, LinkCardIconHelp, LinkCard, GetStartedSectionContent, CustomPopUpContent, NoQuotaPopoverContainer, LinkCardContentSubHeading, LinkCardIconContainer, } from './styles';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { faGraduationCap } from '@fortawesome/pro-regular-svg-icons';
import { faUserTie } from '@fortawesome/pro-regular-svg-icons';
import { useLocation } from 'react-router-dom';
import CustomPopUp from '../CreateApp';
import CreateAppHeader from './../CreateApp/components/CreateAppHeader';
import CreateAppFooter from './../CreateApp/components/CreateAppFooter';
import SelectAppTemplate from './../CreateApp/sheets/SelectAppTemplate';
import CreateAppTypeSelection from './../CreateApp/sheets/CreateAppTypeSelection';
import CreateAppLogoAndName from './../CreateApp/sheets/CreateAppLogoAndName';
import CreateAppGlobalStyleColors from './../CreateApp/sheets/CreateAppGlobalStyleColors';
import CreateAppGlobalStyleText from './../CreateApp/sheets/CreateAppGlobalStyleText';
import { selectAppCreationFlow } from '@project/store/createAppFlow/selectors';
import { openCreateAppFlow, closeCreateAppFlow, openQuotaNotAvailablePopover, } from '@project/store/createAppFlow/actions';
import CreateAppLoading from '../CreateApp/sheets/CreateAppLoading';
import CreateAppEnvironmentVariables from '../CreateApp/sheets/CreateAppEnvironmentVariables';
import { AppCreationScreens } from '../../store/createAppFlow/models';
import TemplateInfoModal from '../CreateApp/components/TemplateInfo';
import RequestTemplate from '../CreateApp/components/RequestTemplate';
import { CommonModal } from '@appspotr/ui-kit';
import { colors } from '../UI-helpers/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { selectConsumptionSummery, selectDevPlanSummery, selectStatusLoading, } from '../../store/orgStatusSummery/selectors';
var GetStartedSection = function () {
    var _a;
    var dispatch = useDispatch();
    var pathname = useLocation().pathname;
    var navigate = useNavigate();
    var pathNameArray = pathname.split('/');
    var orgId = pathNameArray[2];
    var _b = useSelector(selectAppCreationFlow), loading = _b.loading, legacyVersion = _b.legacyVersion, openedTemplateInfo = _b.openedTemplateInfo, creationType = _b.creationType, currentStep = _b.currentStep, selectedTemplate = _b.selectedTemplate, environmentData = _b.environmentData, open = _b.open, isNoQuotaOpen = _b.isNoQuotaOpen;
    var consumptionSummery = useSelector(selectConsumptionSummery);
    var availableApps = (_a = consumptionSummery === null || consumptionSummery === void 0 ? void 0 : consumptionSummery.available) === null || _a === void 0 ? void 0 : _a.apps;
    var devPlanQuotaLoading = useSelector(selectStatusLoading);
    var devPlanStatus = useSelector(selectDevPlanSummery);
    var getCreateAppStatus = function () {
        if ((devPlanStatus === null || devPlanStatus === void 0 ? void 0 : devPlanStatus.status) === 'unset') {
            return 'no-plan';
        }
        else if ((devPlanStatus === null || devPlanStatus === void 0 ? void 0 : devPlanStatus.status) === 'active' && availableApps === 0) {
            return 'no-quota';
        }
        else {
            return null;
        }
    };
    var handleOpenAppCreate = function () {
        dispatch(openCreateAppFlow());
    };
    var handleCloseAppCreate = function () {
        dispatch(closeCreateAppFlow());
    };
    var handleOpenQuotaPopover = function (open) {
        dispatch(openQuotaNotAvailablePopover(open));
    };
    var getSteps = function () {
        var _a;
        if (creationType === 'SCRATCH') {
            if (currentStep === 'SELECT_TYPE') {
                return { previous: null, next: AppCreationScreens.SET_NAME_AND_ICON };
            }
            else if (currentStep === 'SET_NAME_AND_ICON') {
                return {
                    previous: AppCreationScreens.SELECT_TYPE,
                    next: AppCreationScreens.SET_GLOBAL_STYLES_COLOR,
                };
            }
            else if (currentStep === 'SET_GLOBAL_STYLES_COLOR') {
                return {
                    previous: AppCreationScreens.SET_NAME_AND_ICON,
                    next: AppCreationScreens.SET_GLOBAL_STYLES_TEXT,
                };
            }
            else if (currentStep === 'SET_GLOBAL_STYLES_TEXT') {
                return {
                    previous: AppCreationScreens.SET_GLOBAL_STYLES_COLOR,
                    next: null,
                };
            }
            else {
                return {
                    previous: null,
                    next: null,
                };
            }
        }
        else {
            if (currentStep === 'SELECT_TYPE') {
                return { previous: null, next: AppCreationScreens.EXPLORE_TEMPLATES };
            }
            else if (currentStep === 'EXPLORE_TEMPLATES') {
                return {
                    previous: AppCreationScreens.SELECT_TYPE,
                    next: AppCreationScreens.SET_NAME_AND_ICON,
                };
            }
            else if (currentStep === 'SET_NAME_AND_ICON') {
                if ((selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.version) !== null &&
                    ((_a = selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.version) === null || _a === void 0 ? void 0 : _a.minor) <= legacyVersion) {
                    return {
                        previous: AppCreationScreens.EXPLORE_TEMPLATES,
                        next: null,
                    };
                }
                else {
                    return {
                        previous: AppCreationScreens.EXPLORE_TEMPLATES,
                        next: AppCreationScreens.SET_GLOBAL_STYLES_COLOR,
                    };
                }
            }
            else if (currentStep === 'SET_GLOBAL_STYLES_COLOR') {
                return {
                    previous: AppCreationScreens.SET_NAME_AND_ICON,
                    next: AppCreationScreens.SET_GLOBAL_STYLES_TEXT,
                };
            }
            else if (currentStep === 'SET_GLOBAL_STYLES_TEXT') {
                return {
                    previous: AppCreationScreens.SET_GLOBAL_STYLES_COLOR,
                    next: (environmentData === null || environmentData === void 0 ? void 0 : environmentData.length)
                        ? AppCreationScreens.SET_ENVIRONMENT_VARIABLES
                        : null,
                };
            }
            else if (currentStep === 'SET_ENVIRONMENT_VARIABLES') {
                return {
                    previous: AppCreationScreens.SET_GLOBAL_STYLES_TEXT,
                    next: null,
                };
            }
            else {
                return {
                    previous: null,
                    next: null,
                };
            }
        }
    };
    var renderSheetContent = function (step) {
        if (step === 'SELECT_TYPE') {
            return _jsx(CreateAppTypeSelection, {});
        }
        else if (step === 'SET_NAME_AND_ICON') {
            return _jsx(CreateAppLogoAndName, {});
        }
        else if (step === 'SET_GLOBAL_STYLES_COLOR') {
            return _jsx(CreateAppGlobalStyleColors, {});
        }
        else if (step === 'SET_GLOBAL_STYLES_TEXT') {
            return _jsx(CreateAppGlobalStyleText, {});
        }
        else if (step === 'SET_CREATING_APP') {
            return _jsx(CreateAppLoading, {});
        }
        else if (step === 'EXPLORE_TEMPLATES') {
            return _jsx(SelectAppTemplate, {});
        }
        else if (step === 'SET_ENVIRONMENT_VARIABLES') {
            return _jsx(CreateAppEnvironmentVariables, {});
        }
    };
    var getProgress = function () {
        var _a, _b;
        if (creationType === 'SCRATCH') {
            if (currentStep === 'SET_NAME_AND_ICON') {
                return 33;
            }
            else if (currentStep === 'SET_GLOBAL_STYLES_COLOR') {
                return 66;
            }
            else if (currentStep === 'SET_GLOBAL_STYLES_TEXT') {
                return 100;
            }
            else {
                return 0;
            }
        }
        else {
            if (currentStep === 'EXPLORE_TEMPLATES') {
                if (((_a = selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.version) === null || _a === void 0 ? void 0 : _a.minor) <= legacyVersion) {
                    return 50;
                }
                else {
                    return 20;
                }
            }
            else if (currentStep === 'SET_NAME_AND_ICON') {
                if (((_b = selectedTemplate === null || selectedTemplate === void 0 ? void 0 : selectedTemplate.version) === null || _b === void 0 ? void 0 : _b.minor) <= legacyVersion) {
                    return 100;
                }
                else {
                    return 40;
                }
            }
            else if (currentStep === 'SET_GLOBAL_STYLES_COLOR') {
                return 60;
            }
            else if (currentStep === 'SET_GLOBAL_STYLES_TEXT') {
                return 80;
            }
            else if (currentStep === 'SET_ENVIRONMENT_VARIABLES') {
                return 100;
            }
            else {
                return 0;
            }
        }
    };
    return (_jsxs(SectionOuter, { children: [_jsx(SectionHeading, { children: "Get Started" }), _jsxs(GetStartedSectionContent, { children: [_jsx(CommonModal, __assign({ active: isNoQuotaOpen, hideModal: function () {
                            handleOpenQuotaPopover(false);
                        }, title: getCreateAppStatus() === 'no-quota'
                            ? 'App Projects limit exceeded'
                            : 'Requires Active Developer Plan', modalType: "create", cancel: "Dismiss", action: getCreateAppStatus() === 'no-quota'
                            ? 'Upgrade Developer Plan'
                            : 'Buy a Developer Plan', width: '560px', height: '273px', bodyPadding: '0px', margin: '0', disabled: false, onClick: function () {
                            handleOpenQuotaPopover(false);
                            navigate("/organizations/".concat(orgId, "/developerPlans"));
                        } }, { children: getCreateAppStatus() === 'no-quota' ? (_jsxs(NoQuotaPopoverContainer, { children: ["To create a new app, you must have a sufficient number of app projects within your developers plan. ", _jsx("br", {}), _jsx("br", {}), " Please upgrade your plan or adding app projects as an Addons"] })) : (_jsxs(NoQuotaPopoverContainer, { children: ["To create a new app, it is essential to have an active Developer Plan. ", _jsx("br", {}), _jsx("br", {}), " Please ensure that your organization subscribes to a valid Developer Plan with Appspotr."] })) })), _jsx(CustomPopUp, __assign({ top: "0px", bottom: "0px", left: "0px", right: "0px", height: "100%", width: "100%", shown: open, close: handleCloseAppCreate }, { children: _jsxs(CustomPopUpContent, { children: [_jsx(CreateAppHeader, { setOpen: handleCloseAppCreate }), _jsx(TemplateInfoModal, { active: openedTemplateInfo }), _jsx(RequestTemplate, {}), loading ? (_jsx(CreateAppLoading, {})) : (_jsxs(_Fragment, { children: [renderSheetContent(currentStep), currentStep !== 'SELECT_TYPE' && (_jsx(CreateAppFooter, { next: getSteps().next, previous: getSteps().previous, type: creationType, progress: getProgress() }))] }))] }) })), orgId !== 'shared' && (_jsxs(LinkCard, __assign({ disabled: devPlanQuotaLoading || (devPlanStatus === null || devPlanStatus === void 0 ? void 0 : devPlanStatus.status) === undefined, onClick: function () {
                            getCreateAppStatus() === 'no-plan' ||
                                getCreateAppStatus() === 'no-quota'
                                ? handleOpenQuotaPopover(true)
                                : handleOpenAppCreate();
                        } }, { children: [devPlanQuotaLoading || (devPlanStatus === null || devPlanStatus === void 0 ? void 0 : devPlanStatus.status) === undefined ? (_jsx(LinkCardIconContainer, { children: _jsx(FontAwesomeIcon, { color: colors.primary, size: "lg", icon: faSpinner, spin: true }) })) : (_jsx(LinkCardIconAdd, { icon: faPlus })), _jsxs(LinkCardContent, { children: [_jsx(LinkCardContentHeading, { children: "New app" }), _jsx(LinkCardContentSubHeading, { children: "Start from scratch or use a template" })] })] }))), _jsx("a", __assign({ href: "https://academy.appspotr.com/academy/latest/welcome/index.html", target: "_blank", rel: "noopener noreferrer" }, { children: _jsxs(LinkCard, { children: [_jsx(LinkCardIconLearn, { icon: faGraduationCap }), _jsxs(LinkCardContent, { children: [_jsx(LinkCardContentHeading, { children: "Learn Appspotr" }), _jsx(LinkCardContentSubHeading, { children: "Level up your appspotr knowledge" })] })] }) })), _jsx("a", __assign({ href: "https://www.appspotr.com/expert-help", target: "_blank", rel: "noopener noreferrer" }, { children: _jsxs(LinkCard, { children: [_jsx(LinkCardIconHelp, { icon: faUserTie }), _jsxs(LinkCardContent, { children: [_jsx(LinkCardContentHeading, { children: "Expert help" }), _jsx(LinkCardContentSubHeading, { children: "Get help from appspotr experts" })] })] }) }))] })] }));
};
export default GetStartedSection;
